import { Icon } from "src/components/icons"
import { ISegmentTypeIconProps } from "src/components/SegmentPicker/components/SegmentTypeIcon/types"
import { getSegmentTypeIcon } from "src/lib/segment-type"

export const SegmentTypeIcon = (props: ISegmentTypeIconProps) => {
    const { icon, color } = getSegmentTypeIcon(props.type)
    return <Icon icon={icon} size={props.size} color={color} />
}
